import React from "react";
import Lottie from "react-lottie";
import * as image from "../lottie/loading.json";

export default function ComponentName() {
  return (
    <main className="h-screen flex justify-content-center align-items-center">
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: image,
        }}
        height={100}
        width={100}
      />
    </main>
  );
}
